module.exports = __webpack_public_path__ + "static/media/gt-america-standard-light-italic.fb756cf1.woff2";